export const ADD_HEADLINE = "ADD_HEADLINE";
export const REMOVE_HEADLINE = "REMOVE_HEADLINE";
export const CHANGE_HEADLINE = "CHANGE_HEADLINE";

export const ADD_DESCRIPTION = "ADD_DESCRIPTION";
export const REMOVE_DESCRIPTION = "REMOVE_DESCRIPTION";
export const CHANGE_DESCRIPTION = "CHANGE_DESCRIPTION";

export const CHANGE_BUSINESSNAME = "CHANGE_BUSINESSNAME";

export const ADD_IMAGE = "ADD_IMAGE";
export const ADD_IMAGES = "ADD_IMAGES";
export const CLEAR_IMAGES = "CLEAR_IMAGES";

export const UPDATE_IMAGE_STATE = "UPDATE_IMAGE_STATE";

export const ADD_CROPPED_IMAGE = "ADD_CROPPED_IMAGE";
export const REMOVE_CROPPED_IMAGE = "REMOVE_CROPPED_IMAGE";
export const CLEAR_CROPPED_IMAGES = "CLEAR_CROPPED_IMAGES";

export const ADD_CROPPED_LOGO = "ADD_CROPPED_LOGO";
export const REMOVE_CROPPED_LOGO = "REMOVE_CROPPED_LOGO";
export const CLEAR_CROPPED_LOGOS = "CLEAR_CROPPED_LOGOS";

export const CREATE_PREVIEW_IMAGES = "CREATE_PREVIEW_IMAGES";
export const CLEAR_PREVIEW_IMAGES = "CLEAR_PREVIEW_IMAGES";

export const CHANGE_LOADING_STATE = "CHANGE_LOADING_STATE";
